
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';

import { ImpressionTrackingEvents } from '@/enums/events';

import SponsoredRecommendationPoster from '@/components/sponsored-recommendations/SponsoredRecommendationPoster.vue';
import SponsoredRecommendationList from '@/components/sponsored-recommendations/SponsoredRecommendationList.vue';
import SponsoredRecommendationVideo from '@/components/sponsored-recommendations/SponsoredRecommendationVideo.vue';

import type { SnowplowContext, SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { SponsoredAdFragmentFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import type { SRClickTitleEvent } from '@/components/sponsored-recommendations/sponsored-recommendation-types';
import { ObjectType } from '@/@types/graphql-types';
import BackendTrackingMixin from '@/mixins/BackendTracking.vue';

export const SRImpressionTrackingObservableOptions = {
	once: false,
	intersection: {
		threshold: 0.5, // 50% visibility of each element
	},
	throttle: 1000,
};

@Component({
	name: 'SponsoredRecommendationView',
	components: { SponsoredRecommendationPoster, SponsoredRecommendationList, SponsoredRecommendationVideo },
})
export default class SponsoredRecommendationView extends Mixins(BackendTrackingMixin) {
	SRImpressionTrackingObservableOptions = SRImpressionTrackingObservableOptions;
	@Prop({ default: () => [] }) additionalContexts: (SnowplowModuleContext | SnowplowContext)[];
	@Prop({ default: true }) lazy: boolean;
	@Prop({ required: true }) sponsoredAd: SponsoredAdFragmentFragment;
	@Prop({ default: false }) fullWidth: boolean;
	@Prop({ default: () => [] }) supportedObjectTypes: ObjectType[];

	get campaignNode() {
		return this.sponsoredAd.campaign!.node as Extract<
			SponsoredAdFragmentFragment['campaign']['node'],
			{ __typename?: 'Movie' } | { __typename?: 'Show' }
		>;
	}

	get impressionTrackingCategory() {
		return ImpressionTrackingEvents.SPONSORED_RECOMMENDATIONS;
	}

	get impressionTrackingLabel() {
		const {
			campaign: { node, watchNowOffer },
		} = this.sponsoredAd;
		return `${node?.id}_${watchNowOffer?.package.packageId}`;
	}

	get impressionTrackingValue() {
		return this.sponsoredAd.holdoutGroup ? '0' : '1';
	}

	get impressionTrackingProperty() {
		return 'ad';
	}

	get titleObjectId() {
		return this.campaignNode.objectId;
	}

	get titleObjectType() {
		return this.campaignNode.objectType;
	}

	get isListSR() {
		return this.sponsoredAd?.campaign?.node.__typename === 'GenericTitleList';
	}

	get isVideoSR() {
		return !!this.sponsoredAd?.campaign?.promotionalVideo?.url;
	}

	@Emit('onMounted')
	mounted() {}

	@Emit('click')
	click() {}

	navigateTitle({ title, index }: SRClickTitleEvent) {
		const path = title.content.fullPath;
		if (path) {
			this.$router.push({ path });
		}
	}
}
